import { MuteIndicator } from '@components/atoms/MuteIndicator/MuteIndicator'

type Position = 'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'

type ParticipantBadgeProps = {
  name: string
  position?: Position
  className?: string
  isMuted?: boolean
}

const POSITION_CLASSES: Record<Position, string> = {
  'bottom-left': 'bottom-3 left-3',
  'bottom-right': 'bottom-3 right-3',
  'top-left': 'top-3 left-3',
  'top-right': 'top-3 right-3'
}

export const ParticipantBadge = ({ name, position = 'bottom-left', className, isMuted }: ParticipantBadgeProps) => {
  return (
    <div
      className={`absolute ${POSITION_CLASSES[position]} flex items-center gap-1.5 rounded-md bg-black/60 px-1 py-0 lg:px-3 lg:py-1.5 backdrop-blur-sm ${className ?? ''}`}
    >
      <span className="text-xs lg:text-sm font-medium text-white">{name}</span>
      <MuteIndicator isMuted={isMuted ?? false} size="sm" />
    </div>
  )
}
